import { createSlice } from "@reduxjs/toolkit";
const HIT_ODDS_LIMIT = 22;

const hitOddsSlice = createSlice({
  name: "hitOdds",
  initialState: [],
  reducers: {
    setInitialHitOdds(state, action) {
      state = action.payload;

      return state;
    },
    addHitOdd(state, action) {
      state.unshift(action.payload);
      if (state.length > HIT_ODDS_LIMIT) {
        state.pop();
      }
      return state;
    },
    clearHitOdds(state, action) {
      state = [];
      return state;
    }
  }
});

export const { clearHitOdds, addHitOdd, setInitialHitOdds } = hitOddsSlice.actions;
export default hitOddsSlice.reducer;
